import ConditionalToolTip from "components/design/conditionalToolTip";
import ToolTip from "components/design/toolTip";
import {
  ToggleGroup,
  ToggleGroupItem,
} from "components/DesignSystem/ToggleGroup/ToggleGroup";
import { TriangleWarning } from "components/icons/TriangleWarning";
import { ALL, ARCHIVED, COMPLETED, ONGOING } from "constants/task";

export const StatusTab = ({
  setStatus,
  status,
  pendingInvoices = 0,
}: {
  setStatus: (v: string) => void;
  status: string;
  pendingInvoices?: number;
}) => {
  return (
    <div>
      <ToggleGroup
        size="small"
        value={status}
        onValueChange={(value) => {
          setStatus(value);
        }}
      >
        <ToggleGroupItem value={ALL}>All</ToggleGroupItem>
        <ToggleGroupItem value={ONGOING}>Ongoing</ToggleGroupItem>
        <ToggleGroupItem value={COMPLETED}>
          <div>
            <span>
              <ConditionalToolTip
                condition={
                  pendingInvoices > 0 &&
                  `${pendingInvoices} pending support actions`
                }
              >
                <div className="t-flex t-items-center t-gap-1">
                  <span>Completed</span>
                  {pendingInvoices > 0 && (
                    <span className="t-text-orange">
                      <TriangleWarning />
                    </span>
                  )}
                </div>
              </ConditionalToolTip>
            </span>
          </div>
        </ToggleGroupItem>
        <ToggleGroupItem value={ARCHIVED}>Archived</ToggleGroupItem>
      </ToggleGroup>
    </div>
  );
};
